import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import { ValidationRules, ValidationController, validateTrigger } from "aurelia-validation";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import UserSearchVM from "./UserSearchVM";
import InformationEditorVM from "./InformationEditorVM";
import PermissionVM from "./PermissionVM";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./UserGroupDetailView.html"))
export default class UserGroupDetailEditorVM extends EditorVMBase {
    Code: string;

    InformationEditorVM: InformationEditorVM;
    UserSearchVM: UserSearchVM;
    PermissionVM: PermissionVM;

    constructor() {
        super();

    }

    activate(params) {
        this.Load(params.id);
    }

    Load(code: string) {
        var self = this;
        if (code != null && code != 'undefined') {
            self.Code = code;
            self.PrepareChildVMs();
        } else {
            this.BeginEdit();
            self.InformationEditorVM = new InformationEditorVM(null);
        }
    };

    PrepareChildVMs() {
        super.PrepareChildVMs();

        if (this.Code != null && this.Code != "" && this.Code != undefined && this.Code != "00000000-0000-0000-0000-000000000000") {
            this.AddChildNode(new InformationEditorVM(this.Code));
            this.AddChildNode(new UserSearchVM(this.Code));
            this.AddChildNode(new PermissionVM(this.Code));
            this.InformationEditorVM = this.ChildNodeGroups["default"][0];
            this.UserSearchVM = this.ChildNodeGroups["default"][1];
            this.PermissionVM = this.ChildNodeGroups["default"][2];
        }
    }
}
